import { BaseModel } from '~/models/baseModel';

export class GroupExtensionModel extends BaseModel {
    public allowSeller:boolean;
    public allowBuyer:boolean;
    public allowClasser:boolean;
    public allowContractor:boolean;
    public allowGrower:boolean;
    public isOpen:boolean;
}